import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAllAPKs, getFeaturedAPKs } from "../../apkStoreAPI";
import APKCard from "./APKCard";
import "./apkStoreFeed.css";

export default function APKStoreFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [apks, setApks] = useState([]);
  const [featuredApks, setFeaturedApks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [sortBy, setSortBy] = useState("newest");
  const [priceType, setPriceType] = useState("all");

  const categories = [
    "all", "games", "productivity", "social", "entertainment", "education",
    "music", "photo_video", "tools", "business", "health", "shopping",
    "travel", "news", "books", "personalization"
  ];

  useEffect(() => {
    loadAPKs();
    loadFeatured();
  }, [category, sortBy, priceType]);

  const loadAPKs = async () => {
    try {
      setLoading(true);
      const filters = {
        category: category !== "all" ? category : undefined,
        sortBy,
        priceType: priceType !== "all" ? priceType : undefined,
        page: 1,
        limit: 20
      };
      const response = await getAllAPKs(filters);
      setApks(response.apks || []);
    } catch (error) {
      console.error("Erro ao carregar APKs:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadFeatured = async () => {
    try {
      const response = await getFeaturedAPKs();
      setFeaturedApks(response.apks || []);
    } catch (error) {
      console.error("Erro ao carregar APKs em destaque:", error);
    }
  };

  return (
    <div className="apk_store_feed">
      <div className="apk_store_filters">
        <div className="filter_group">
          <label>Categoria:</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat === "all" ? "Todas" : cat.charAt(0).toUpperCase() + cat.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="filter_group">
          <label>Ordenar:</label>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="newest">Mais Recentes</option>
            <option value="oldest">Mais Antigos</option>
            <option value="downloads">Mais Baixados</option>
            <option value="rating">Melhor Avaliados</option>
            <option value="trending">Em Alta</option>
          </select>
        </div>

        <div className="filter_group">
          <label>Preço:</label>
          <select value={priceType} onChange={(e) => setPriceType(e.target.value)}>
            <option value="all">Todos</option>
            <option value="free">Grátis</option>
            <option value="paid">Pagos</option>
          </select>
        </div>
      </div>

      {featuredApks.length > 0 && (
        <div className="apk_featured_section">
          <h2>🌟 Em Destaque</h2>
          <div className="apk_grid">
            {featuredApks.map((apk) => (
              <APKCard key={apk._id} apk={apk} />
            ))}
          </div>
        </div>
      )}

      <div className="apk_main_section">
        <h2>📱 Aplicativos</h2>
        {loading ? (
          <div className="apk_loading">Carregando...</div>
        ) : apks.length > 0 ? (
          <div className="apk_grid">
            {apks.map((apk) => (
              <APKCard key={apk._id} apk={apk} />
            ))}
          </div>
        ) : (
          <div className="apk_empty">Nenhum aplicativo encontrado</div>
        )}
      </div>
    </div>
  );
}
